import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	categoryPostWrapper: {
		backgroundColor : theme.other.colors.background.tertiary,
		display         : "flex",
		flexDirection   : "column",
		borderRadius    : "10px"
	},
	categoryPostImage: {
		borderTopLeftRadius  : "10px",
		borderTopRightRadius : "10px"
	},
	infoContainer: {
		display       : "flex",
		flexDirection : "column",
		width         : "100%",
		gap           : "2rem",
		padding       : "1rem"
	},
	heading: {
		fontSize        : "2rem",
		fontWeight      : "500",
		wordBreak       : "break-word",
		textOverflow    : "ellipsis",
		WebkitLineClamp : 2,
		overflow        : "hidden",
		display         : "-webkit-box",
		WebkitBoxOrient : "vertical",
		cursor          : "pointer"
	},
	postContent: {
		color           : theme.other.colors.text.secondary,
		wordBreak       : "break-word",
		textOverflow    : "ellipsis",
		WebkitLineClamp : 3,
		overflow        : "hidden",
		display         : "-webkit-box",
		WebkitBoxOrient : "vertical"
	},
	seperator: {
		borderRadius : "50%",
		height       : "3px",
		width        : "3px",
		background   : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite80 : theme.other.paletteNew.secondaryDarkGrey,
		margin       : "0 1rem"

	},
	tagsContainer: {
		display      : "flex",
		alignItems   : "center",
		marginBottom : "1rem"
	},
	dateTag: {
		color    : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite80 : theme.other.paletteNew.secondaryDarkGrey,
		fontSize : "1.2rem"
	},
	nameTag: {
		color    : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite80 : theme.other.paletteNew.secondaryDarkGrey,
		fontSize : "1.2rem"
	}

} ) );
